var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33441 6.48167L16.3344 7.48489L20.8617 3.80643L16.1029 1.8L7.69132 2.00579L3.34406 4.3209L8.33441 6.48167Z",
    fill: "#7CFFF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33443 6.48166L6.328 12.0637L17.9036 12.4495L15.7685 6.48166H8.33443Z",
    fill: "#00A5EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7686 6.48166L20.8618 3.80642L24.0001 7.15047L17.6206 12.1408L15.7686 6.48166Z",
    fill: "#00DBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34405 4.3209L0 8.25659L6.32797 12.0637L8.3344 6.48167L3.34405 4.3209Z",
    fill: "#00DCFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.328 12.0637L12.373 22.4817L17.6206 12.1408L6.328 12.0637Z",
    fill: "#105BC4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.25659L12.373 22.4817L6.32797 12.0637L0 8.25659Z",
    fill: "#2181E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 7.15047L12.373 22.4817L17.6206 12.1408L24.0001 7.15047Z",
    fill: "#00AFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34406 4.3209L20.8617 3.80643L16.1029 1.8L7.69132 2.00579L3.34406 4.3209Z",
    fill: "#B6FFF9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.328 12.0637C6.328 12.0637 6.7653 9.2598 8.33444 6.48166C7.94858 8.8225 6.328 12.0637 6.328 12.0637Z",
    fill: "#7CFFF9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7685 6.48166C15.537 7.9479 17.3377 11.8321 17.6206 12.1408C17.5435 10.2116 15.7685 6.48166 15.7685 6.48166Z",
    fill: "#7CFFF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.fea6baa7f478ed01491392bbc4065bc2.svg";
export { ForwardRef as ReactComponent };